import {
    ChevronRight,
    HeartHandshake,
    LogOut,
    Pencil,
    Smartphone,
} from 'lucide-react';
import { Link } from 'react-router-dom';

export type MeuPerfilQuickNavProps = {
    onLogout: () => void;
    onOpenPaymentsHistory: () => void;
    onOpenEditProfile: () => void;
};

export function MeuPerfilQuickNav({ onLogout, onOpenPaymentsHistory, onOpenEditProfile }: MeuPerfilQuickNavProps) {
    const rowClass =
        'group flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left text-[15px] text-white/90 transition-colors hover:bg-white/[0.04] md:px-5 md:py-3';

    return (
        <nav
            className="mb-6 overflow-hidden rounded-xl border border-white/[0.1] bg-neutral-900/40 shadow-sm shadow-black/20 md:mb-8 md:bg-neutral-900/50"
            aria-label="Atalhos do perfil"
        >
            <button type="button" onClick={onOpenEditProfile} className={rowClass}>
                <span className="flex min-w-0 items-center gap-3">
                    <Pencil size={18} className="shrink-0 text-orange-400/90" strokeWidth={1.75} />
                    <span className="truncate">Editar perfil</span>
                </span>
                <ChevronRight size={18} className="shrink-0 text-white/25 transition-colors group-hover:text-orange-400/80" />
            </button>
            <div className="h-px bg-white/[0.06]" />
            <button type="button" onClick={onOpenPaymentsHistory} className={rowClass}>
                <span className="flex min-w-0 items-center gap-3">
                    <HeartHandshake size={18} className="shrink-0 text-orange-400/90" strokeWidth={1.75} />
                    <span className="truncate">Pagamentos / Doações</span>
                </span>
                <ChevronRight size={18} className="shrink-0 text-white/25 transition-colors group-hover:text-orange-400/80" />
            </button>
            <div className="h-px bg-white/[0.06]" />
            <Link to="/colecao?aba=offline" className={rowClass}>
                <span className="flex min-w-0 items-center gap-3">
                    <Smartphone size={18} className="shrink-0 text-orange-400/90" strokeWidth={1.75} />
                    <span className="truncate">Página offline</span>
                </span>
                <ChevronRight size={18} className="shrink-0 text-white/25 transition-colors group-hover:text-orange-400/80" />
            </Link>
            <div className="h-px bg-white/[0.06]" />
            <button
                type="button"
                onClick={onLogout}
                className="flex w-full items-center justify-center gap-2 px-4 py-3.5 text-sm text-white/50 transition-colors hover:bg-red-500/[0.06] hover:text-red-300/95 md:py-3"
            >
                <LogOut size={18} className="opacity-80" />
                Sair da conta
            </button>
        </nav>
    );
}
